import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

import PhoneStep from "./components/PhoneStep";
import CodeStep from "./components/CodeStep";

export default function Login() {
    const navigate = useNavigate();

    const token = useSelector((state) => state.login.token);

    const [step, setStep] = useState(() => {
        return Number(sessionStorage.getItem("step") || 1);
    });

    const [code, setCode] = useState("");

    const [authData, setAuthData] = useState({
        email: "",
        password: "",
        fullName: "",
    });

    useEffect(() => {
        sessionStorage.setItem("step", step);
    }, [step]);

    useEffect(() => {
        if (token) {
            navigate("/");
        }
    }, [token, navigate]);

    return (
        <>
            {step === 1 && (
                <PhoneStep
                    authData={authData}
                    setAuthData={setAuthData}
                    onNext={() => setStep(2)}
                />
            )}

            {step === 2 && (
                <CodeStep
                    code={code}
                    setCode={setCode}
                    authData={authData}
                    onBack={() => setStep(1)}
                    onNext={() => setStep(3)}
                    setStep={setStep}
                />
            )}
        </>
    );
}